import { render, staticRenderFns } from "./ConfigModelosDocListagem.vue?vue&type=template&id=664ea13b&scoped=true&lang=pug&"
import script from "./ConfigModelosDocListagem.vue?vue&type=script&lang=js&"
export * from "./ConfigModelosDocListagem.vue?vue&type=script&lang=js&"
import style0 from "./ConfigModelosDocListagem.vue?vue&type=style&index=0&id=664ea13b&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664ea13b",
  null
  
)

export default component.exports